import React, { useContext } from "react";
import _ from "lodash";
import Summaryutils from "../../utils/SummaryUtils";
import { Grid, List, ListItem } from "@material-ui/core";
import { RequestSummaryContext } from "../../context/RequestSummaryContext";
import useStoreConfig from "../../hooks/useStoreConfig";
import { UserContext } from "../../context/UserContext";
import "../../styles/summary.scss";

const heading = [
  {
    label: "Request ID",
    fields: [
      {
        type: "id",
        value: "requestId",
      },
    ],
  },
  {
    label: "Request Name",
    fields: [
      {
        type: "text",
        value: "name",
      },
    ],
    width: "10px",
  },
];

const getHeaders = (role, jobType) => {
  const headers = [
    {
      label: "Department",
      fields: [
        {
          type: "text",
          value: "requestor.deptName",
        },
      ],
      width: "10px",
    },
    {
      label: "Due Date",
      fields: [
        {
          type: "date",
          value: "rolledUpDate",
        },
      ],
    },
    {
      label: "Due Time",
      fields: [
        {
          type: "text",
          value: "dueTime",
        },
      ],
    },
    {
      label: "Job Type",
      fields: [
        {
          type: "text",
          value: "jobType",
        },
      ],
      specialHandling: "jobType",
    },
    {
      label: "Source Type",
      fields: [
        {
          type: "text",
          value: "sourceType",
        },
      ],
      specialHandling: "idType",
    },
    {
      label: "Status",
      fields: [
        {
          type: "text",
          value: "rolledUpStatus",
        },
      ],
      specialHandling: "status",
    },
    {
      label: "Job Count",
      fields: [
        {
          type: "text",
          value: "totalJobCount",
        },
      ],
    },
    {
      label: "Date Submitted",
      fields: [
        {
          type: "dateTime",
          value: "submittedDate",
        },
      ],
      width: "10px",
    },
    {
      label: "Created By",
      fields: [
        {
          type: "email",
          value: ["requestor.fullName", "requestor.email"],
        },
      ],
      width: "10px",
    },
  ];

  if (
    role === "cr_api" || role === "mediarequest" ||
    ((role === "superadmin" || role === 'globaladmin' || role === 'requestor' || role === 'ops') && 
    (jobType === "CONTENT_REQUEST_API" || jobType === "MEDIA_REQUEST"))
  ) {
    return [
      ...headers,
      {
        label: "Content Type",
        fields: [
          {
            type: "text",
            value: "contentType",
          },
        ],
      },
    ];
  }

  return [
    ...headers,
    {
      label: "CC",
      fields: [
        {
          type: "cc",
          value: "notificationList",
        },
      ],
      width: "10px",
    },
    {
      label: "Notes",
      fields: [
        {
          type: "text",
          value: "notes",
        },
      ],
      width: "10px",
    },
  ];
}

const summaryHeader = (headersArr, data, title, icon, renderFn) => {
  return (
    <div
      className="w-100"
      key={"summary_container_" + title}>
      <div className="summaryHeaderTitleContainer">
        <label className="summaryHeaderTitle">
          {Summaryutils.hasEmptyFields(heading[0].fields, data)
            ? null
            : Summaryutils.getValue(heading[0].fields, data) + (Summaryutils.hasEmptyFields(_.get(heading[1], "fields"), data) ? "" : " :  " + Summaryutils.getValue(_.get(heading[1], "fields"), data))}
        </label>
      </div>
      <Grid container spacing={1} className="m-0" key={"summary_grid" + title}>
        {_.map(headersArr, (header, index) => {
          return Summaryutils.hasEmptyFields(header.fields, data) ? null : (
            <Grid item xs={4} key={header.label + index} className="p-0 mb-1">
              <div className="summaryFieldsDiv">
                <label className="summaryFieldsLabel">
                  {header.label + " :  "}
                </label>
                {_.includes(Summaryutils.getValue(header.fields, data), "\n")
                  ? Summaryutils.getValue(header.fields, data)
                      .split("\n")
                      .map((col, key) => (
                        <div key={"mailKey" + key} className={header.label === "Status" ? "summaryFieldsStatus" : "summaryFieldsInfo"}>
                          {_.includes(col, ".com") ? (
                            <a style={{ color: "rgb(44, 130, 190)" }} href={"mailto:" + col}>
                              {col}
                            </a>
                          ) : (
                              <span>
                                {col + "  "}
                              </span>
                          )}
                        </div>
                      ))
                  : renderFn(Summaryutils.getValue(header.fields, data), header)}
              </div>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
};

export const renderHeaderTable = (tableHeaders, data, title, index) => {
  return (
    <div
      style={{
        marginBottom: "20px",
        width: "100%",
        background: "#adb5bd26",
        borderRadius: "12px",
        padding: "10px",
      }}
      id={"summary_container_" + title + index}>
      <h6
        style={{
          margin: "10px",
          color: "#C4CFDD",
          fontSize: "20px",
          fontFamily: "Gilroy Regular",
          lineHeight: 1,
        }}>
        {title}
      </h6>
      {renderList(tableHeaders, data, title, index)}
    </div>
  );
};
export const renderList = (headersArray, data, title, index) => {
  return (
    <List style={{ padding: "0px" }} key={"summary_list" + title + index}>
      {_.map(headersArray, (header, key) => {
        return Summaryutils.hasEmptyFields(header.fields, data) ? null : (
          <ListItem key={"summary_listItem" + header.label + index + key}>
            <span style={{ whiteSpace: "pre-wrap" }}>
              {header.label}
              <span>
                {" :  "}
                {_.includes(Summaryutils.getValue(header.fields, data), "\n")
                  ? Summaryutils.getValue(header.fields, data)
                      .split("\n")
                      .map((col, keyValue) => (
                        <React.Fragment key={keyValue}>
                          {col}
                          <br />
                        </React.Fragment>
                      ))
                  : Summaryutils.getValue(header.fields, data)}
              </span>
            </span>
          </ListItem>
        );
      })}
    </List>
  );
};

const SummaryHeader = () => {
  const { request } = useContext(RequestSummaryContext);
  const { ConfigStore } = useStoreConfig();
  const { userRole } = useContext(UserContext);
  const renderFn = (val, header) => {
    const specialId = _.get(header, "specialHandling", "");
    switch (specialId) {
      case "status":
        const findRole = userRole !== "requestor" || request["jobType"] === "MEDIA_REQUEST" ? "ops" : userRole;
        const findValue = _.result(_.find(ConfigStore.statuses(), { role: findRole }), "statuses");
        let labelValue = _.find(findValue, ["value", val]);
        labelValue = _.get(labelValue, "label", "");
        return labelValue;
      case "idType":
        const sourceConfig = _.find(ConfigStore.sourceTypes(), ["value", val]);
        return _.get(sourceConfig, "label", "");
      case "jobType":
        const idType = _.find(ConfigStore.jobTypeList(), ["value", val]);
        return _.get(idType, "label", "");
      default:
        return val;
    }
  };

  return _.isEmpty(request) ? null : summaryHeader(getHeaders(userRole, _.get(request, 'jobType')), request, "Request Details", null, renderFn);
};

export default SummaryHeader;
